"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommandType;
(function (CommandType) {
    CommandType["ADD_TIME"] = "ADD_TIME";
    CommandType["PER_QUESTION_SUBMISSION"] = "PER_QUESTION_SUBMISSION";
    CommandType["RESUBMIT"] = "RESUBMIT";
    CommandType["UNSUBMIT"] = "UNSUBMIT";
    CommandType["TEACHER_FEEDBACK"] = "TEACHER_FEEDBACK";
    CommandType["REMOVE_TEACHER_FEEDBACK"] = "REMOVE_TEACHER_FEEDBACK";
    CommandType["TEACHER_GRADE"] = "TEACHER_GRADE";
    CommandType["REMOVE_TEACHER_GRADE"] = "REMOVE_TEACHER_GRADE";
    CommandType["SET_PROGRESS"] = "SET_PROGRESS";
    CommandType["UPDATE_SCORM"] = "UPDATE_SCORM";
    CommandType["PEER_REVIEW"] = "PEER_REVIEW";
    CommandType["PEER_REVIEW_RECEIVED"] = "PEER_REVIEW_RECEIVED";
    CommandType["UPDATE_BLOCK_PERFORMANCE"] = "UPDATE_BLOCK_PERFORMANCE";
    CommandType["FORCE_COMPLETE"] = "FORCE_COMPLETE";
    CommandType["RESET_PROGRESS"] = "RESET_PROGRESS";
    CommandType["ADD_SUBMISSION"] = "ADD_SUBMISSION";
    CommandType["INCREMENT_ACCESS_COUNT"] = "INCREMENT_ACCESS_COUNT";
    // Checkpoint
    CommandType["ADD_CHECKPOINT_SUBMISSION"] = "ADD_CHECKPOINT_SUBMISSION";
    CommandType["EVALUATE_CHECKPOINT"] = "EVALUATE_CHECKPOINT";
    CommandType["CHANGE_REVIEWER"] = "CHANGE_REVIEWER";
    // ILT
    CommandType["REGISTER_SESSION"] = "REGISTER_SESSION";
    CommandType["REGISTER_SESSIONS"] = "REGISTER_SESSIONS";
    CommandType["UNREGISTER_SESSION"] = "UNREGISTER_SESSION";
    CommandType["UNREGISTER_SESSIONS"] = "UNREGISTER_SESSIONS";
    CommandType["MARK_ATTENDANCE"] = "MARK_ATTENDANCE";
    CommandType["SUBSCRIBE_FOR_ILT_UPDATES"] = "SUBSCRIBE_FOR_ILT_UPDATES";
    // Assign
    CommandType["ASSIGN_CONTENT"] = "ASSIGN_CONTENT";
    CommandType["DEASSIGN_CONTENT"] = "DEASSIGN_CONTENT";
    CommandType["CHANGE_DUE_DATE"] = "CHANGE_DUE_DATE";
    CommandType["UPDATE_CONTENT"] = "UPDATE_CONTENT";
    CommandType["SWITCH_TO_LATEST_CONTENT"] = "SWITCH_TO_LATEST_CONTENT";
    CommandType["EVALUATE_CONTENT"] = "EVALUATE_CONTENT";
    // New Assessment Player
    CommandType["FLAG_ASSIGNMENT_QUESTION"] = "FLAG_ASSIGNMENT_QUESTION";
    CommandType["CHECK_ANSWER"] = "CHECK_ANSWER";
    CommandType["SET_ASSIGNMENT_START_TIME"] = "SET_ASSIGNMENT_START_TIME";
    CommandType["UPDATE_ILT_SESSION_STATE"] = "UPDATE_ILT_SESSION_STATE";
})(CommandType = exports.CommandType || (exports.CommandType = {}));
//# sourceMappingURL=index.js.map